import { CASCADE_ENUM } from '../../../../services/enum.service';
import {
  ActionCellRenderer,
  ActionTypes,
} from '../../../../utils/custom-renderer/action-cell-renderer';
import { formatCodDate, getFormattedNumber } from '../../../../utils/formatting';
import type { BuyerInterest } from './buyer-interest';
import { CUSTOM_HEADER_TOOLTIPS, headerWithTooltipColParams } from '../../../../utils/grid';
import { CreditProfileLegendTooltipComponent } from '../../../../utils/custom-renderer/credit-profile-legend-tooltip-component';

export enum COLUMN_FIELDS {
  TICKER = 'TICKER',
  TECHNOLOGY = 'TECHNOLOGY',
  ISO = 'ISO',
  SETTLEMENT_POINT = 'SETTLEMENT_POINT',
  TARGET_COD = 'TARGET_COD',
  VOLUME = 'REQUESTED_VOLUME',
  PRICE = 'FIXED_PRICE',
  TENOR = 'TENOR_START_DATE',
  COLLATERAL = 'COLLATERAL',
  NODAL_BASIS = 'NODAL_BASIS',
  LME = 'LME',
  ACTIONS = 'ACTIONS',
}

export function RFQ_COLUMNS(context: BuyerInterest) {
  return [
    {
      field: COLUMN_FIELDS.TICKER,
      headerName: 'Ticker',
      suppressMenu: true,
      flex: 2,
    },

    {
      field: COLUMN_FIELDS.TECHNOLOGY,
      headerName: 'Technology',
      suppressMenu: true,
      flex: 2,
    },
    {
      field: COLUMN_FIELDS.ISO,
      headerName: 'ISO',
      suppressMenu: true,
      flex: 2,
    },
    {
      field: COLUMN_FIELDS.SETTLEMENT_POINT,
      headerName: 'Settlement Point',
      suppressMenu: true,
      flex: 2,
    },
    {
      field: COLUMN_FIELDS.TARGET_COD,
      headerName: 'COD',
      valueFormatter: (params) => {
        return formatCodDate(params.data.TARGET_COD);
      },
      suppressMenu: true,
      flex: 2,
    },
    {
      field: COLUMN_FIELDS.VOLUME,
      headerName: 'Volume (MW)',
      suppressMenu: true,
      flex: 2,
      valueFormatter: (params) => getFormattedNumber(params.data.VOLUME),
    },
    {
      field: COLUMN_FIELDS.PRICE,
      headerName: 'PRICE($)',
      suppressMenu: true,
      flex: 2,
    },
    {
      field: COLUMN_FIELDS.TENOR,
      headerName: 'Tenor',
      valueFormatter: (params) => {
        return formatCodDate(params.data.TENOR_START_DATE);
      },
      suppressMenu: true,
      flex: 2,
    },
    {
      field: COLUMN_FIELDS.COLLATERAL,
      headerName: 'Credit Profile ($/MW)',
      suppressMenu: true,
      flex: 2,
      valueFormatter: (params) => getFormattedNumber(params.data.COLLATERAL),
      ...headerWithTooltipColParams(CUSTOM_HEADER_TOOLTIPS.CREDIT_PROFILE),
    },
    {
      field: COLUMN_FIELDS.NODAL_BASIS,
      headerName: 'Nodal Basis',
      suppressMenu: true,
      flex: 2,
    },
    {
      field: COLUMN_FIELDS.LME,
      headerName: 'LME',
      suppressMenu: true,
      flex: 2,
    },
    {
      field: COLUMN_FIELDS.ACTIONS,
      headerName: 'Actions',
      suppressMenu: true,
      width: 110,
      suppressRowClickSelection: true,
      pinned: 'right',
      cellStyle: {
        'padding-right': '7px',
        'box-shadow': '-5px 0px 15px 0px rgba(0, 0, 0, 0.2)',
      },
      cellRenderer: ActionCellRenderer,
      cellRendererParams: (params) => {
        const compareBtn = {
          name: 'Compare',
          callback: (detail) => {
            // context.$emit('confirmTrade', detail)
          },
          type: ActionTypes.CREATE,
          actionName: 'compare',
        };
        const actions = [compareBtn];
        const enabled = true;
        return {
          actions,
          enabled,
        };
      },
    },
  ];
}
